<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header align-items-center">
    <div class="modal-title f-20">Update Multiple Rulebooks</div>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
        aria-hidden="true" (click)="closeAction()"></button>
</div>
<div mat-dialog-content class="p-0">
    <div class="border-0">
        <div class="bulk_update_rule_row">
            <div class="left_part d-flex justify-content-between flex-column  py-4 px-3">
                <label class="control-label fw">Owner</label>
                <div>
                    <mat-chip-grid #ownerList class="cdk-overlay-pane owner_chiplist">
                        <mat-chip-row *ngFor="let owner of ownerDD" [selectable]="selectable" [removable]="removable"
                            (removed)="removeOwner(owner)">
                            {{owner}}
                            <mat-icon matChipRemove *ngIf="removable && currentUserRole === 'Compliance Enterprise'"
                                class="clear-icons">clear
                            </mat-icon>
                        </mat-chip-row>
                        <input class="form-control form-control-sm mat-autodd-input border-bottom w-100"
                            #trigautoOwner="matAutocompleteTrigger"
                            [attr.disabled]="currentUserRole !== 'Compliance Enterprise' ? 'disabled' : null"
                            #ownerInput [formControl]="searchOwnerCntrl" [matAutocomplete]="ownerAutocomplete"
                            [matChipInputFor]="ownerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                            (matChipInputTokenEnd)="addOwner($event)">
                    </mat-chip-grid>
                    <mat-autocomplete #ownerAutocomplete="matAutocomplete"
                        (optionSelected)="selectedOwnerEvent($event)">
                        <mat-option *ngFor="let owner of searchedOwner" [value]="owner">
                            {{owner.name}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
                <div class="text-right">
                    <button [disabled]="ownerDD.length == 0" type="button" class="btn btn-primary btn-sm mt-2"
                        (click)="updateOwnerRule()">Update</button>
                </div>
            </div>
            <div class="right_part d-flex flex-column gap-2 py-4 px-3">
                <div class="cursor-pointer" *ngIf="commonService.checkPlanTypeAction('LRR')" >
                    <input type="checkbox" [(ngModel)]="isRead" checked *ngIf="isRead"
                        style="vertical-align: middle;" />
                    <input type="checkbox" [(ngModel)]="isRead" *ngIf="!isRead" style="vertical-align: middle;" />
                    <span> Rule Read</span>
                </div>
                <div class="cursor-pointer" *ngIf="commonService.checkPlanTypeAction('LRA')">
                    <input type="checkbox" [(ngModel)]="isApplicable" checked *ngIf="isApplicable"
                        style="vertical-align: middle;" />
                    <input type="checkbox" [(ngModel)]="isApplicable" *ngIf="!isApplicable"
                        style="vertical-align: middle;" />
                    <span> Applicable</span>
                </div>
                <div class="cursor-pointer" *ngIf="commonService.checkPlanTypeAction('LRO')">
                    <input type="checkbox" [(ngModel)]="isOperative" checked *ngIf="isOperative"
                        style="vertical-align: middle;" />
                    <input type="checkbox" [(ngModel)]="isOperative" *ngIf="!isOperative"
                        style="vertical-align: middle;" />
                    <span> Operative</span>
                </div>
                <div class="text-right" *ngIf="commonService.checkPlanTypeAction('LRO') || commonService.checkPlanTypeAction('LRA') || commonService.checkPlanTypeAction('LRR')">
                    <button type="button" class="btn btn-primary btn-sm" (click)="updateCheckRule()">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>